var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOntimeflag(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9274 6.68691L11.6904 4.16787L12.9509 0.959766C13.0355 0.744434 13.0097 0.499707 12.8818 0.307617C12.7539 0.115527 12.5407 0 12.3124 0H2.6875C2.30783 0 2 0.313086 2 0.7V13.3C2 13.6869 2.30783 14 2.6875 14C3.06716 14 3.37499 13.6869 3.37499 13.3V7.7H12.3124C12.5508 7.7 12.772 7.57422 12.8972 7.36777C13.0224 7.16133 13.0338 6.90361 12.9274 6.68691Z",
    fill: "#24CA49"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOntimeflag);
export default __webpack_public_path__ + "static/media/on time flag.2a40f7aa85f480402ff1cbf9dbb9ddb0.svg";
export { ForwardRef as ReactComponent };